export default __webpack_public_path__ + "static/media/03.9e9bdd44.jpg";